import { createAction, props } from '@ngrx/store';
import {
  NadajPrzesylkeType,
  ScreenType,
  SposobDoreczeniaType,
  SposobNadaniaType,
} from 'src/app/enums/enums';

export const changeNadajPrzesylkeTyp = createAction(
  '[Navigation] Change NadajPrzesylkeTyp',
  props<{ nadajPrzesylkeTyp: NadajPrzesylkeType }>()
);

export const changeScreen = createAction(
  '[Navigation] Change Screen',
  props<{ screen: ScreenType }>()
);

export const changeSposobNadaniaTyp = createAction(
  '[Navigation] Change SposobNadaniatyp',
  props<{ sposobNadaniaTyp: SposobNadaniaType }>()
);

export const changeSposobDoreczeniaTyp = createAction(
  '[Navigation] Change SposobDoreczeniaTyp',
  props<{ sposobDoreczeniaTyp: SposobDoreczeniaType }>()
);

export const changeSposobNadaniaStepNumber = createAction(
  '[Navigation] Change SposobNadaniaStepNumber',
  props<{ sposobNadaniaStepNumber: number }>()
);
